export default {
      id: "common__online_notifications-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__online_notifications",
      toString: function () {
        return this.url;
      }
    }